import React from 'react';
import PropTypes from 'prop-types';
import { MultipleFilter } from 'common/designer-modules/modules/content-library/filters';
import { STORE_TYPES } from 'common/designer-modules/siteDesigner';

const StoreFilters = ({
   isMobile,
   onFilterChange,
   filters,
   categories = [],
}) => {
   return (
      <>
         <MultipleFilter
            isMobile={ isMobile }
            name='Type'
            data={ STORE_TYPES }
            selectedValue={ filters?.type || [] }
            isMultiplSelect
            onFilterChange={ (value) => {
               onFilterChange('type', value, true)
            } }
            filterValueKey='id'
         />
         <MultipleFilter
            isMobile={ isMobile }
            selectedValue={ filters?.categories || [] }
            filterValueKey='id'
            searchPlaceholder='Search categories'
            name='Category'
            data={ categories }
            onFilterChange={ (value) => {
               onFilterChange('categories', value, true)
            } }
         />
      </>
   )
};

StoreFilters.propTypes = {
   filters: PropTypes.object,
   onFilterChange: PropTypes.func,
   isMobile: PropTypes.bool,
   categories: PropTypes.array,
};

export default StoreFilters;
